import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { TripAttributesGps } from '../dto/visit-gps.interface';

/**
 * Date Cell Renderer
 *
 *
 * @example
 * ```typescript
 * {
 *   field: 'date',
 *   headerName: 'Día',
 *   cellRenderer: DateCellRendererComponent,
 *   minWidth: 250
 * }
 * ```
 */
@Component({
  selector: 'app-date-cell-renderer',
  standalone: true,
  imports: [CommonModule, FormatOtherDateHourPipe],
  template: `
    <div class="leading-tight">
      <span class="font-semibold">{{ day }}<br></span>
      <span class="font-descrip">{{ params.data?.dateHourStart | FormatDateHour: false }}</span>
    </div>
  `,
})
export class DateCellRendererComponent implements CellRenderer<TripAttributesGps> {
  @Input() params!: CellRendererParams<TripAttributesGps>;
  day?: string;

  ngOnInit() {
    const fecha = this.params.data?.dateHourStart;
    if (fecha) {
      const date = new Date(fecha);
      const rawDay = date.toLocaleDateString('es-ES', { weekday: 'long' });
      this.day = rawDay.charAt(0).toUpperCase() + rawDay.slice(1);
    }
  }
}
